import React from 'react';
import Icon from '../../../components/AppIcon';

const CandidatePreview = ({ candidate }) => {
  if (!candidate) return null;

  return (
    <div className="bg-muted/30 rounded-xl p-6 mb-6 border border-border">
      <div className="flex items-start space-x-4">
        <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="User" size={28} className="text-primary" />
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-lg font-semibold text-foreground">
              {candidate?.title}
            </h3>
            <div className="flex items-center space-x-1 bg-success/10 px-2 py-1 rounded-full">
              <Icon name="Star" size={14} className="text-success fill-current" />
              <span className="text-sm font-medium text-success">{candidate?.matchPercentage}% match</span>
            </div>
          </div>
          
          <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-3">
            <div className="flex items-center space-x-1">
              <Icon name="MapPin" size={14} />
              <span>{candidate?.location}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Briefcase" size={14} />
              <span>{candidate?.experience}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={14} />
              <span>{candidate?.availability}</span>
            </div>
          </div>
          
          <div className="mb-3">
            <h4 className="text-sm font-medium text-foreground mb-2">Top Skills</h4>
            <div className="flex flex-wrap gap-2">
              {candidate?.skills?.slice(0, 6)?.map((skill, index) => (
                <span
                  key={index}
                  className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-md"
                >
                  {skill}
                </span>
              ))}
              {candidate?.skills?.length > 6 && (
                <span className="px-2 py-1 bg-muted text-muted-foreground text-xs font-medium rounded-md">
                  +{candidate?.skills?.length - 6} more
                </span>
              )}
            </div>
          </div>
          
          <div className="bg-warning/10 border border-warning/20 rounded-lg p-3">
            <div className="flex items-start space-x-2">
              <Icon name="Lock" size={16} className="text-warning mt-0.5" />
              <div className="text-sm">
                <div className="font-medium text-foreground">Contact Information Locked</div>
                <div className="text-muted-foreground">
                  Unlock to reveal name, photo, email, and phone number
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidatePreview;